module.exports = __webpack_public_path__ + "static/media/5h.5a709afa.png";